import React from "react";
import {
    Alert, IconButton, Typography,
} from "@mui/material";
import { useNotificationCenter } from "react-toastify/addons/use-notification-center";
import Stack from "@mui/material/Stack";
import { format } from "date-fns";
import useStore from "../../store";
import { PTMDialog, PTMInput } from "../../Components";
import PTMIcon from "../../Components/PTMIcon";

function NotificationCenter() {
    const {
        notifications,
        clear,
        markAllAsRead,
        markAsRead,
    } = useNotificationCenter();

    const notificationsOpen = useStore((store) => store.notifications.open);
    const setNotificationsOpen = useStore((store) => store.notifications.setOpen);

    const [showAll, setShowAll] = React.useState(false);

    return (
        <PTMDialog
            icon="comment"
            title="Benachrichtigungen"
            open={notificationsOpen}
            onClose={() => setNotificationsOpen(false)}
            fixedWidth={375}
            everywhereVisible
            footerButtons={
                [
                    {
                        name: "Leeren",
                        color: "info",
                        icon: "trash",
                        click: () => clear(),
                        disabled: notifications.length === 0,
                    },
                    {
                        name: "Alle als gelesen markieren",
                        color: "success",
                        icon: "check",
                        click: () => markAllAsRead(),
                        disabled: notifications.length === 0,
                    },
                    {
                        name: "Schließen",
                        color: "error",
                        icon: "times",
                        click: () => setNotificationsOpen(false),
                    },
                ]
            }
        >
            <PTMInput
                fullWidth
                type="switch"
                trueLabel="Gelesene Benachrichtigungen anzeigen"
                checked={showAll}
                onChange={(e) => setShowAll(e.target.checked)}
            />
            <Stack style={{ height: "calc(400px - 25px)", overflowX: "auto" }}>
                {notifications.filter((notification) => !notification.read || showAll).map((notification) => (
                    <Alert
                        key={notification.id}
                        style={{ margin: 5 }}
                        severity={["error", "info", "success", "warning"].includes(notification.type) ? notification.type : "info"}
                        action={(
                            <IconButton
                                style={{ marginRight: 10, marginTop: -2 }}
                                color="success"
                                popover="Als gelesen markieren"
                                onClick={() => markAsRead(notification.id)}
                                // variant="contained"
                                disabled={notification.read}
                            >
                                <PTMIcon icon="check" />
                            </IconButton>
                        )}
                    >
                        <Typography variant="subtitle2">{format(notification.createdAt, "dd.MM.yyyy, HH:mm:ss")}</Typography>
                        {notification.content}
                    </Alert>
                ))}
                {notifications.filter((notification) => !notification.read || showAll).length === 0 && (
                    <Alert
                        style={{ margin: 5 }}
                        severity="info"
                    >
                        Keine Benachrichtigungen vorhanden
                    </Alert>
                )}
            </Stack>
        </PTMDialog>
    );
}
export default React.memo(NotificationCenter);
